// client/src/components/common/ThemeSwitcher.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiSun, FiCoffee, FiMoon, FiStar } from 'react-icons/fi';
import { getTheme, setTheme, THEME_OPTIONS } from '../../utils/theme';
import { useAuth } from '../../context/AuthContext';

const THEME_ICONS = {
  default: <FiSun />,
  warm: <FiCoffee />,
  dark: <FiMoon />
};

// 全局页面风格切换器(默认/暖色系/暗色系), 放在侧边栏底部
// VIP 用户额外显示"贴牌"入口: 自定义品牌标题/背景图(替代原系统设置里的VIP视图)
const ThemeSwitcher = () => {
  const [theme, setThemeState] = useState(getTheme());
  const navigate = useNavigate();
  const { isVip } = useAuth();

  const change = (key) => {
    setTheme(key);
    setThemeState(key);
  };

  return (
    <div className="px-3 py-3 border-t border-[#d0d7de]">
      <div className="flex items-center justify-between">
        <span className="text-xs text-[#8b949e]">页面风格</span>
        <div className="flex items-center gap-1">
          {THEME_OPTIONS.map((opt) => (
            <button
              key={opt.key}
              type="button"
              title={opt.label}
              onClick={() => change(opt.key)}
              className={`p-1.5 rounded-md transition-colors ${
                theme === opt.key
                  ? 'bg-[#ddf4ff] text-[#0969da]'
                  : 'text-[#8b949e] hover:bg-[#f6f8fa] hover:text-[#24292f]'
              }`}
            >
              {THEME_ICONS[opt.key]}
            </button>
          ))}
          {/* VIP贴牌入口: 自定义标题/背景图, 仅VIP可见 */}
          {isVip && (
            <button
              type="button"
              title="贴牌设置(自定义标题/背景图)"
              onClick={() => navigate('/brand')}
              className="ml-1 flex items-center gap-1 px-2 py-1.5 rounded-md text-xs text-[#9a6700] bg-[#fff8c5] hover:bg-[#f8e58c] transition-colors"
            >
              <FiStar className="text-xs" />
              贴牌
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ThemeSwitcher;
